
import React, { PureComponent } from 'react';
import ModalFixed from './ModalFixed';

import ModalPINForm from './ModalPINForm';
import ModalCaptchaForm from './ModalCaptchaForm';
import ModalTextForm from './ModalTextForm';

import { CodeSendHandlersIds } from 'constant/CodeSendHandlersIds.js';
import ModalConfirmMethodsForm from "./ModalConfirmMethodsForm";

export const popupName = "operation-confirmation";

const funcStub = () => { };

class ModalHeader extends PureComponent {

    render() {
        return (
            <div className="modal-verification-new__sms-top">
                {/* {(this.props.handlers.length > 1) &&
                    <div className="control-dots control-dots_big control-dots_gray">
                        {
                            this.props.handlers.map((item, index) => {
                                return (
                                    <button key={index}
                                        type="button"
                                        tabIndex="-1"
                                        className={"control-dots__dot" + (this.props.step === index ? " control-dots__dot_current" : "")}>
                                    </button>
                                );
                            })
                        }
                    </div>
                } */}
                <a className="btn-new btn-new--icon modal-new__close" href="javascript:void(0);" data-dismiss="modal">
                    <svg className="icon icon--close" id="icon--close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.99629 4.85076C5.38681 4.46024 6.01998 4.46024 6.4105 4.85076L19.2658 17.7061C19.6564 18.0966 19.6564 18.7298 19.2658 19.1203L19.0945 19.2916C18.704 19.6821 18.0709 19.6821 17.6803 19.2916L4.825 6.43627C4.43447 6.04574 4.43447 5.41258 4.825 5.02206L4.99629 4.85076Z" />
                        <path
                            d="M4.85215 19.1203C4.46162 18.7298 4.46162 18.0966 4.85215 17.7061L17.7075 4.85075C18.098 4.46023 18.7312 4.46023 19.1217 4.85075L19.293 5.02205C19.6835 5.41257 19.6835 6.04574 19.293 6.43626L6.43765 19.2916C6.04713 19.6821 5.41396 19.6821 5.02344 19.2916L4.85215 19.1203Z" />
                    </svg>
                </a>
            </div>
        );
    }
}

class ModalSMSFooter extends PureComponent {

    render() {
        return null;
    }
}

const handlerSequence = [
    CodeSendHandlersIds.HANDLER_SMS,
    CodeSendHandlersIds.HANDLER_WORD,
    CodeSendHandlersIds.HANDLER_EMAIL,
    CodeSendHandlersIds.HANDLER_PASSWORD,
    CodeSendHandlersIds.HANDLER_CAPTCHA,
    CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA,
    CodeSendHandlersIds.HANDLER_GOOGLE,
    CodeSendHandlersIds.HANDLER_WHATS_APP,
    CodeSendHandlersIds.HANDLER_TELEGRAM,
    CodeSendHandlersIds.HANDLER_FLASHCALL,
    CodeSendHandlersIds.HANDLER_VOICECALL
];

export class ModalOperationConfirmation extends PureComponent {

    constructor() {
        super();
        this.textForms = {
            [CodeSendHandlersIds.HANDLER_SMS]: true,
            [CodeSendHandlersIds.HANDLER_GOOGLE]: true,
            [CodeSendHandlersIds.HANDLER_EMAIL]: true,
            [CodeSendHandlersIds.HANDLER_PASSWORD]: true,
            [CodeSendHandlersIds.HANDLER_WHATS_APP]: true,
            [CodeSendHandlersIds.HANDLER_TELEGRAM]: true,
            [CodeSendHandlersIds.HANDLER_FLASHCALL]: true,
            [CodeSendHandlersIds.HANDLER_VOICECALL]: true
        };
        this.captchaForms = {
            [CodeSendHandlersIds.HANDLER_CAPTCHA]: true
        };
        this.pinForms = {
            [CodeSendHandlersIds.HANDLER_WORD]: true
        };

    }

    applyHandlersSort(handlers) {
        const handlersObj = handlers.reduce((result, item) => {
            result[item] = true;
            return result;
        }, {});
        let handlersRest = [...handlers].filter((item) => {
            return !~handlerSequence.indexOf(item);
        });
        const result = [...handlerSequence].filter((item) => {
            return handlersObj[item];
        }).concat(handlersRest);
        return result;
    }

    renderForm(handlerId, index) {
        return (
            <div key={handlerId}
                className="modal-body popup-slide-form">
                {!!this.pinForms[handlerId] &&
                    <ModalPINForm
                        handlerId={handlerId}
                        disableTabs={this.props.step !== index}
                        isLast={this.props.step === this.props.settings.handlers.length - 1}
                        {...this.props}
                    />
                }
                {!!this.textForms[handlerId] &&
                    <ModalTextForm
                        handlerId={handlerId}
                        isUseRecallButtons={handlerId === CodeSendHandlersIds.HANDLER_SMS
                            || handlerId === CodeSendHandlersIds.HANDLER_WHATS_APP
                        }
                        disableTabs={this.props.step !== index}
                        isLast={this.props.step === this.props.settings.handlers.length - 1}
                        {...this.props}
                    />
                }
                {!!this.captchaForms[handlerId] &&
                    <ModalCaptchaForm
                        handlerId={handlerId}
                        disableTabs={this.props.step !== index}
                        isLast={this.props.step === this.props.settings.handlers.length - 1}
                        {...this.props}
                    />
                }
            </div>
        );
    }

    render() {
        const stepCount = this.props.settings.handlers.length;
        /*

            CodeSendHandlersIds.
            CodeSendHandlersIds.HANDLER_SMS
            CodeSendHandlersIds.HANDLER_GOOGLE
            CodeSendHandlersIds.HANDLER_WORD
            CodeSendHandlersIds.HANDLER_EMAIL
            CodeSendHandlersIds.HANDLER_PASSWORD
            CodeSendHandlersIds.HANDLER_CAPTCHA

            handleSubmit(event) {
                event.preventDefault();
                this.props.onSubmit({
                    text: this.state.text,
                    handlerId: this.props.handlerId,
                });
            }

        */

        if (this.props.settings.action === 'confirmMethods') {
            return (
                <ModalConfirmMethodsForm {...this.props} />
            );
        } else {
            // reverse для "сначала форма кода подтверждения, потом PIN форма"
            const handlers = this.applyHandlersSort(this.props.settings.handlers);
            handlers.reverse();
            
            return (
            <ModalFixed
                name={popupName}
                header={<ModalHeader {...this.props} />}
                footer={<ModalSMSFooter />}
                autoFocusFirstInput={true}
            >
                <div
                className="popup-slides"
                style={{
                    width: stepCount * 100 + "%",
                    transform: "translateX(" + -((100 / stepCount) * this.props.step) + "%)",
                }}
                >
                {handlers.map(
                    (handlerId, index) => {
                    return this.renderForm(handlerId, index);
                    }
                )}
                </div>
            </ModalFixed>
            );
        }
    }
}